import { styled } from '@mui/material';
import { ButtonStyled, getClassSizes } from 'v3/shared/components/Button/defaultStyles';
import { CustomButtomProps } from './types';

export const FlexButtonStyles = styled(ButtonStyled)<CustomButtomProps>(
  ({ theme, fullWidth, $backgroundColor, $outline, size = 'medium' }) => ({
    width: fullWidth ? '100%' : 'unset',
    padding: '0rem 2rem',
    borderRadius: '4rem',
    border: $outline ? '1px solid white' : 'unset',
    backgroundColor: $backgroundColor || theme.palette.tertiary.main,

    ...getClassSizes[size],

    '&:hover': {
      backgroundColor: $backgroundColor || theme.palette.tertiary.light,
    },
    '&:disabled': {
      opacity: 0.6,
    },
  }),
);
